import{B as z}from"./chunk-BaseElement-QCmfBlzK.js";import{c as M}from"./chunk-constructorio-kL1h0Ctx.js";import{x as n,T as x}from"./chunk-lit-element-CULRVKo8.js";import{c as $}from"./chunk-repeat-CLr2jifB.js";import{t as D}from"./chunk-custom-element-BhZVzxrc.js";import{n as h}from"./chunk-property-BXqvfTtY.js";import"./chunk-constructorio-DDhIvy8f.js";import"./chunk-_commonjsHelpers-Cpj98o6Y.js";import"./chunk-directive-CF8sV3Lr.js";import"./chunk-directive-helpers-R4cBqjor.js";var E=Object.defineProperty,L=Object.getOwnPropertyDescriptor,m=(e,t,r,s)=>{for(var a=s>1?void 0:s?L(t,r):t,c=e.length-1,i;c>=0;c--)(i=e[c])&&(a=(s?i(t,r,a):i(a))||a);return s&&a&&E(t,r,a),a};let g=class extends z{constructor(){super(...arguments),this.textContent="",this.textSort="",this.textFilter="",this.textFilterCounter="",this.textFiltersCounter="",this.textDataSeeResult="",this.textDataSeeResults="",this.textFrom="",this.textTo="",this.textHideCount="",this.textViewAllCount="",this.textApply="",this.textClearAll="",this.dataResultsGridWithCountOne="",this.dataResultsGridWithCountOther="",this.resultsPerPage=36,this.collectionHandle="",this.collectionsData={},this.facetsCheckboxVisibleLimit=8,this.currentPage=1,this.enableBundle=!1,this.textFilterResults="",this._constructorResponseID=0,this._skipUrlUpdate=!1}async connectedCallback(){super.connectedCallback();const e=new URLSearchParams(window.location.search);this.currentPage=Number(e.get("page"))||1,this._skipUrlUpdate=!0,this.fetchProducts(),window.addEventListener("popstate",this.onPopState.bind(this)),await this.updateComplete,this._skipUrlUpdate=!1}disconnectedCallback(){window.removeEventListener("popstate",this.onPopState.bind(this)),super.disconnectedCallback()}async onPopState(){this._skipUrlUpdate=!0;try{const e=new URLSearchParams(window.location.search),t=Number(e.get("page"))||1;t!==this.currentPage&&(this.currentPage=t),await this.fetchProducts()}finally{this._skipUrlUpdate=!1}}async fetchProducts(){try{const e=await this.getPaginatedResults(this.currentPage);if(e){const{results:t,totalPages:r,facets:s,sortOptions:a,totalResults:c}=e;if(!t)return;const i=t&&t.length>0?t.map(p=>{var b,f;return(b=p.data)!=null&&b.handle?{handle:(f=p.data)==null?void 0:f.handle}:{}}):[];this.collectionsData={facets:s,sortOptions:a,cards:i,paginationIds:Array.from({length:r},(p,b)=>b+1),totalResults:c};const u=s==null?void 0:s.find(p=>this.hasName(p)&&p.name==="price");u&&(this._productsMaxPrice=u.max);const l=this.getTotalFiltersApplied(this.collectionsData.facets);this.textFilterResults=l==0?this.textFilter:l>1?this.textFiltersCounter:this.textFilterCounter,l>0&&(this.textFilterResults=this.textFilterResults.replace("{{ count }}",String(l)))}}catch(e){console.error("Error fetching browse results:",e)}}hasName(e){return typeof e=="object"&&e!==null&&"name"in e}createSearchParams(e,t){const r={...e,...t&&{sort_by:t}},s=new URLSearchParams;for(const[a,c]of Object.entries(r))Array.isArray(c)?c.forEach(i=>s.append(`filter_${a}`,i)):s.append(`filter_${a}`,c);return s.toString()}updateURLHash(e){if(this._skipUrlUpdate)return;const t=new URLSearchParams(e);this.currentPage>1?t.set("page",this.currentPage.toString()):t.delete("page");const r=t.toString();history.pushState({processedParams:r},"",`${window.location.pathname}${r&&"?".concat(r)}`)}isEmptyObj(e){return Object.keys(e).length===0&&e.constructor===Object}async getPaginatedResults(e=1,t=this.resultsPerPage,r={},s=""){let a={...r},c=s;if(s==""&&this.isEmptyObj(r)){const i=new URLSearchParams(window.location.search),u={};for(const[b,f]of i.entries()){if(!b.startsWith("filter_"))continue;const v=b.replace(/^filter_/,""),w=u[v];w===void 0?u[v]=v==="price"?[f]:f:Array.isArray(w)?w.push(f):u[v]=[w,f]}const{sort_by:l,...p}=u;c=Array.isArray(l)?l[0]:l||"",a={...p}}this.isEmptyObj(r)&&s=="relevance"&&(c=""),this.updateURLHash(this.createSearchParams(a,c));try{const i=await M.browse({filterName:"group_id",filterValue:this.collectionHandle,section:"Products",page:e,resultsPerPage:t,filters:a,sortBy:c,sortOrder:c.includes("ascending")?"ascending":"descending"},{enabled:!0,expiryMs:12e4});if(!i.response)return;const u=i.response.results,l=i.response.total_num_results,p=Math.ceil((l??1)/this.resultsPerPage),b=i.response.sort_options,f=i.response.facets;return{results:u,totalPages:p,currentPage:e,facets:f,sortOptions:b,totalResults:l}}catch(i){return console.error("Constructor.io pagination error:",i),null}}async filterChanged(e,t){var w;if(!e)return;const r=t==null?void 0:t.hasAttribute("target-clear-all-filters"),s=(t==null?void 0:t.tagName)==="FACET-REMOVE"&&t.dataset.name=="price";if(t)if(t.id.toLowerCase().includes("mobile")){if(t.getAttribute("type")==="radio"){const o=document.querySelector('select[name="sort_by"]');o&&(o.value=t.value,o.dispatchEvent(new Event("change",{bubbles:!0})))}else{const o=t.id.replace("Mobile","Desktop"),d=document.getElementById(o);d&&(d.getAttribute("type")==="checkbox"?d.checked=t.checked:d.value=t.value,d.dispatchEvent(new Event("change",{bubbles:!0})))}return}else if(t.tagName.toLowerCase()==="select"){const o=document.querySelector(`[type="radio"][name="sort_by"][value="${t.value}"]`);o.checked=!0}else{const o=document.getElementById(t.id.replace("Desktop","Mobile"));o&&(t.type=="checkbox"?o.checked=t.checked:o.value=t.value)}const a=(w=e.querySelector("#SortOptionsFormDesktop select"))==null?void 0:w.value;let c=1;const i=e.querySelector("[aria-current='page']");i&&!t&&i.textContent&&(c=parseFloat(i.textContent));const u=parseFloat(e.getAttribute("data-pagination-results-per-page")),l=e.querySelector("[target-filters]"),p=new FormData(l),b={};for(const[o,d]of p.entries())b[o]?Array.isArray(b[o])?b[o].push(d):b[o]=[b[o],d]:b[o]=d;const f={};if(!r){const o=l.querySelector('[name="filter.v.price.gte"]'),d=o?o.getAttribute("min"):null,k=o?o.getAttribute("data-max"):null;let C,S;for(const[_,F]of Object.entries(b))_==="filter.v.price.gte"?typeof F=="string"&&(C=F):_==="filter.v.price.lte"?typeof F=="string"&&(S=F):_!=="sort_by"&&(f[_]=F);if((C&&d&&parseFloat(C)!=parseFloat(d)||S&&k&&parseFloat(S)!=parseFloat(k))&&!s){const _=C??"",F=S??"";f.price=[`${_}-${F}`]}}this.scrollIntoView();const v=await this.getPaginatedResults(c,u,f,a);if(this._constructorResponseID++,v){const{results:o,totalPages:d,facets:k,sortOptions:C,totalResults:S}=v;if(!o)return;const _=k==null?void 0:k.map(y=>({...y,opened:"status"in y&&typeof y.status=="object"&&Object.keys(y.status).length>0||"options"in y&&Array.isArray(y.options)&&y.options.some(P=>P.status!=="")})),F=o&&o.length>0?o.map(y=>{var P,A;return(P=y.data)!=null&&P.handle?{handle:(A=y.data)==null?void 0:A.handle}:{}}):[];this.collectionsData={facets:_,sortOptions:C,cards:F,paginationIds:Array.from({length:d},(y,P)=>P+1),totalResults:S};const R=this.getTotalFiltersApplied(this.collectionsData.facets);this.textFilterResults=R==0?this.textFilter:R>1?this.textFiltersCounter:this.textFilterCounter,R>0&&(this.textFilterResults=this.textFilterResults.replace("{{ count }}",String(R))),this.scrollIntoView({behavior:"smooth",block:"start"})}}paginateHandleClick(e){var a,c;const t=e.target,r=(c=(a=t.parentElement)==null?void 0:a.parentElement)==null?void 0:c.querySelectorAll("button:not([data-direction])"),s=parseInt(t==null?void 0:t.textContent);this.currentPage=s,r==null||r.forEach(i=>{var p;const l=parseInt((p=i.querySelector("span"))==null?void 0:p.textContent)==s;i.classList.toggle("border-t-foreground",l),i.classList.toggle("border-t-border",!l),l?(i.setAttribute("aria-current","page"),this.filterChanged(t.closest("collection-results-section"))):i.removeAttribute("aria-current")})}paginateArrowClick(e){var a,c,i,u;const t=e.target,r=(c=(a=t.parentElement)==null?void 0:a.parentElement)==null?void 0:c.querySelector("[aria-current='page']"),s=(u=(i=t.parentElement)==null?void 0:i.parentElement)==null?void 0:u.querySelectorAll("button:not([data-direction])");if(r&&s&&t){const l=Array.from(s).indexOf(r),p=parseFloat(t==null?void 0:t.getAttribute("data-direction"));p>0&&l<s.length-1&&s[l+1].click(),p<0&&l>0&&s[l-1].click()}}applyFilterEvent(e){const t=e.target;this.currentPage=1,this.filterChanged(t.closest("collection-results-section"),t)}clearAllFilters(e){e.preventDefault(),this.applyFilterEvent(e)}handleSelectChange(e){this.applyFilterEvent(e)}handleCheckboxChange(e){this.applyFilterEvent(e)}handleInputChange(e){this.applyFilterEvent(e)}handleize(e){return e.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-$/,"").replace(/^-/,"")}getTotalFiltersApplied(e){return(e==null?void 0:e.reduce((t,r)=>{const s=r.type!="range"?r.options.filter(a=>a.status==="selected").length:Object.hasOwn(r.status,"min")&&Object.hasOwn(r.status,"max")&&(r.status.min!=r.min||r.status.max<(this._productsMaxPrice||r.max))?1:0;return t+s},0))||0}getFacetsHTML(e,t,r){var c,i,u;const s=this.getTotalFiltersApplied(e),a=s==0?this.textApply.replace("{{ count }}","0"):(((c=this.collectionsData)==null?void 0:c.totalResults)??0)>1?this.textDataSeeResults:this.textDataSeeResult;return n`
      <div class="flex h-full w-full flex-col">
        <div
          class="flex-grow${t=="Mobile"?" overflow-auto":x}"
        >
          ${$(e??[],l=>l.name+t+this._constructorResponseID,l=>n`
              <details
                class="group/details border-b border-t-border"
                ?open="${t!="Mobile"||l.opened||l.type==="range"}"
              >
                <summary
                  class='focus-inset group/filter-dropdown md:after:content-[" "] relative flow-root cursor-pointer max-md:px-xs max-md:py-md md:pointer-events-none md:cursor-auto md:pb-xs md:pt-sm md:after:pointer-events-none md:after:absolute md:after:left-0 md:after:top-0 md:after:z-10 md:after:block md:after:h-full md:after:w-full'
                >
                  <div class="flex w-full items-center justify-between text-sm">
                    <span
                      class="${window.brand=="NG"?"text-t-foreground-secondary font-normal":"font-medium"} text-heading-6 capitalize"
                      >${l.display_name}</span
                    >
                    <span class="hidden group-open/details:block">
                      <svg-icon
                        src="icon-minus"
                        class="block md:hidden"
                        style="--icon-size: 13px;"
                      ></svg-icon>
                    </span>
                    <span class="block group-open/details:hidden">
                      <svg-icon
                        src="icon-plus"
                        class="block md:hidden"
                        style="--icon-size: 13px;"
                      ></svg-icon>
                    </span>
                  </div>
                </summary>
                ${(()=>{var b,f,v,w;const p=l.display_name.toLowerCase();switch(!0){case p.includes("price"):return n`
                        ${l.type==="range"?n`
                              <div
                                class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                              >
                                <price-range-slider class="block max-w-[258px]">
                                  <div
                                    class="slider-track relative mx-auto h-1 w-[95%] cursor-pointer rounded-full bg-t-disabled"
                                    data-slider-track
                                  >
                                    <!-- Active track area -->
                                    <div
                                      class="active-track absolute h-1 rounded-full bg-t-accent-01"
                                      data-active-track
                                      style="left: 0%; width: 100%;"
                                    ></div>

                                    <!-- Handles -->
                                    <div
                                      class="min-handle absolute -ml-2.5 -mt-2 h-5 w-5 cursor-grab rounded-full border-2 border-t-foreground bg-t-background shadow-md"
                                      data-min-handle
                                      style="left: 0%;"
                                    ></div>
                                    <div
                                      class="max-handle absolute -ml-2.5 -mt-2 h-5 w-5 cursor-grab rounded-full border-2 border-t-foreground bg-t-background shadow-md"
                                      data-max-handle
                                      style="left: 100%;"
                                    ></div>
                                  </div>

                                  <div class="mt-5 flex items-center gap-3">
                                    <div class="relative flex">
                                      <span
                                        class="field-currency text-body absolute left-2.5 top-2.5 z-10"
                                        >$</span
                                      >
                                      <div class="group flex flex-col gap-2xs">
                                        <div class="group peer relative w-full">
                                          <input
                                            class="body bg-gray-50 remove-arrow peer text-body block h-sm-forms-inputheight w-full appearance-none border border-t-foreground-secondary bg-t-background px-sm-forms-padding py-2.5 !pl-5 pt-sm-forms-padding text-t-foreground rounded-forms-radius group-[[error]]:border-[transparent] group-[[error]]:ring-2 group-[[error]]:ring-u-error focus:border-t-foreground focus:outline-none focus:ring-0 disabled:border-t-border disabled:text-t-border lg:h-lg-forms-inputheight lg:px-lg-forms-padding lg:pt-lg-forms-padding"
                                            placeholder=" "
                                            type="number"
                                            id="${t}-Filter-Price-GTE"
                                            name="filter.v.price.gte"
                                            value="${l.status.min}"
                                            data-pattern="d| |,|."
                                            min="0.00"
                                            max="${(b=this._productsMaxPrice)==null?void 0:b.toFixed(2)}"
                                            data-max="${(f=this._productsMaxPrice)==null?void 0:f.toFixed(2)}"
                                            inputmode="decimal"
                                            @input=${this.handleInputChange}
                                            @change=${this.handleInputChange}
                                          />
                                          <label
                                            for="${t}-Filter-Price-GTE"
                                            class="caption absolute start-sm-forms-padding top-3.5 z-10 hidden origin-[0] -translate-y-2.5 scale-75 transform text-t-foreground-secondary duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-2.5 peer-focus:scale-75 peer-focus:text-t-foreground peer-disabled:text-t-border lg:start-sm-forms-padding rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                                          >
                                            ${this.textFrom}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <span
                                      class="text-utility-regular text-t-foreground"
                                      >to</span
                                    >
                                    <div class="relative flex">
                                      <span
                                        class="field-currency text-body absolute left-2.5 top-2.5 z-10"
                                        >$</span
                                      >
                                      <div class="group flex flex-col gap-2xs">
                                        <div class="group peer relative w-full">
                                          <input
                                            class="body bg-gray-50 remove-arrow peer text-body block h-sm-forms-inputheight w-full appearance-none border border-t-foreground-secondary bg-t-background px-sm-forms-padding py-2.5 !pl-5 pt-sm-forms-padding text-t-foreground rounded-forms-radius group-[[error]]:border-[transparent] group-[[error]]:ring-2 group-[[error]]:ring-u-error focus:border-t-foreground focus:outline-none focus:ring-0 disabled:border-t-border disabled:text-t-border lg:h-lg-forms-inputheight lg:px-lg-forms-padding lg:pt-lg-forms-padding"
                                            placeholder=" "
                                            type="number"
                                            id="${t}-Filter-Price-LTE"
                                            name="filter.v.price.lte"
                                            value="${l.status.max}"
                                            data-pattern="d| |,|."
                                            min="0.00"
                                            max="${(v=this._productsMaxPrice)==null?void 0:v.toFixed(2)}"
                                            data-max="${(w=this._productsMaxPrice)==null?void 0:w.toFixed(2)}"
                                            inputmode="decimal"
                                            @input=${this.handleInputChange}
                                            @change=${this.handleInputChange}
                                          />
                                          <label
                                            for="${t}-Filter-Price-LTE"
                                            class="caption absolute start-sm-forms-padding top-3.5 z-10 hidden origin-[0] -translate-y-2.5 scale-75 transform text-t-foreground-secondary duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-2.5 peer-focus:scale-75 peer-focus:text-t-foreground peer-disabled:text-t-border lg:start-sm-forms-padding rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                                          >
                                            ${this.textTo}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </price-range-slider>
                              </div>
                            `:x}
                      `;case p.includes("color"):return n`
                        ${l.type==="multiple"?n`
                              <div
                                id="FacetFiltersForm${t}_details-content_filter.p.m.custom.color_group"
                                sub-section-id="FacetFiltersForm${t}_details-content_filter.p.m.custom.color_group"
                                class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                              >
                                <ul
                                  class="list-unstyled space-y-xs md:space-y-2xs"
                                  role="list"
                                >
                                  ${$(l.options,o=>o.value+t,(o,d)=>n`
                                      <li class="py-2xs">
                                        <div class="group/swatch">
                                          <input
                                            type="checkbox"
                                            id="FacetFiltersForm${t}_input_filter.p.m.custom.color_group${d}"
                                            name="${l.name}"
                                            value="${o.value}"
                                            class="sr-only"
                                            .checked=${o.status!=""}
                                            @change=${this.handleCheckboxChange}
                                          />
                                          <label
                                            for="FacetFiltersForm${t}_input_filter.p.m.custom.color_group${d}"
                                            title="gid://shopify/Metaobject/103948976181"
                                            class="text-body flex cursor-pointer items-center gap-x-xs"
                                          >
                                            <span
                                              class="relative block aspect-square max-h-[18px] w-[var(--swatch--size,_2rem)] max-w-[18px] overflow-clip rounded-full border border-solid border-t-border bg-[--swatch--background] bg-cover bg-[position:var(--swatch-focal-point,_initial)] bg-origin-border ring-t-foreground ring-offset-2 transition duration-300 ease-in-out [background-image:var(--swatch--background)] group-focus-within/swatch:ring-2 group-focus-within/swatch:ring-[--swatch--background] group-focus-within/swatch:ring-opacity-50 group-focus-within/swatch:ring-offset-2 group-has-[:disabled]/swatch:opacity-30 group-has-[:checked]/swatch:ring-1"
                                              style="--swatch--background: var(--swatch-${this.handleize(o.display_name)});"
                                            ></span>
                                            <span
                                              class="group-has-[:disabled]/swatch:text-t-disabled"
                                            >
                                              <span aria-hidden="true">
                                                <span class="capitalize"
                                                  >${o.display_name}</span
                                                >
                                              </span>
                                              <span class="sr-only"
                                                >${o.display_name}</span
                                              >
                                            </span>
                                          </label>
                                        </div>
                                      </li>
                                    `)}
                                </ul>
                              </div>
                            `:x}
                      `;case p.includes("review"):return n`
                        ${l.type==="multiple"?n`
                              <div
                                id="FacetFiltersForm${t}_details-content_filter.p.m.custom.rating_tier"
                                sub-section-id="FacetFiltersForm${t}_details-content_filter.p.m.custom.rating_tier"
                                class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                              >
                                <ul
                                  class="list-unstyled flex flex-col-reverse gap-y-xs md:gap-y-2xs"
                                  role="list"
                                >
                                  ${$(l.options,o=>o.value+t,(o,d)=>n` <li>
                                        <div
                                          class="group/checkbox inline-flex h-[1.813rem] items-center gap-x-xs"
                                        >
                                          <label
                                            class="relative flex cursor-pointer items-center overflow-clip rounded-[1px]"
                                            for="FacetFiltersForm${t}_input_filter.p.m.custom.rating_tier${d}"
                                          >
                                            <input
                                              type="checkbox"
                                              class="${window.brand=="NG"?"rounded-[2px] border-t-foreground-secondary":"border-blue-gray-200"} peer relative size-4 cursor-pointer appearance-none border transition-all checked:border-t-foreground disabled:border-t-border"
                                              id="FacetFiltersForm${t}_input_filter.p.m.custom.rating_tier${d}"
                                              value="${o.value}"
                                              name="rating_tier"
                                              aria-labelledby="FacetFiltersForm${t}_input_filter.p.m.custom.rating_tier${d}_label"
                                              .checked=${o.status!=""}
                                              @change=${this.handleCheckboxChange}
                                            />
                                            <span
                                              class="${window.brand=="NG"?"bg-t-foreground-secondary":"bg-p-darkest"} pointer-events-none absolute left-2/4 top-2/4 flex size-3 h-full w-full -translate-x-2/4 -translate-y-2/4 items-center justify-center text-p-lightest opacity-0 transition-opacity peer-checked:opacity-100 peer-disabled:border-t-border peer-disabled:text-t-border"
                                            >
                                              <svg-icon
                                                src="icon-checkbox-tick"
                                                class="block"
                                                style="--icon-size: 12px;"
                                              ></svg-icon>
                                            </span>
                                          </label>
                                          <label
                                            class="text-body mt-px cursor-pointer select-none text-t-foreground group-has-[:disabled]/checkbox:pointer-events-none group-has-[:disabled]/checkbox:text-t-border"
                                            for="FacetFiltersForm${t}_input_filter.p.m.custom.rating_tier${d}"
                                          >
                                            <div>
                                              <p
                                                id="FacetFiltersForm${t}_input_filter.p.m.custom.rating_tier${d}_label"
                                                class="text-body block leading-none text-t-foreground group-has-[:disabled]/checkbox:text-t-disabled"
                                              >
                                                <span aria-hidden="true">
                                                </span>
                                              </p>
                                              <div
                                                class="flex items-center gap-xs group-has-[:disabled]/checkbox:opacity-50"
                                              >
                                                <div
                                                  class="${window.brand=="TFC"?"gap-[0.063rem]":"gap-1"} flex items-center"
                                                >
                                                  ${$([1,2,3,4,5],k=>"star"+k+t,k=>k<=parseFloat(o.value)?n`<svg-icon
                                                            src="icon-star-full"
                                                            class="block text-t-accent-01"
                                                            style="--icon-size: 16px;"
                                                          ></svg-icon>`:n`<svg-icon
                                                            src="icon-star-empty"
                                                            class="${window.brand=="NG"?"text-t-disabled":"text-t-foreground-secondary"} block"
                                                            style="--icon-size: 16px;"
                                                          ></svg-icon>`)}
                                                </div>
                                              </div>

                                              <span class="sr-only"
                                                >${o.value}
                                              </span>
                                              <p></p>
                                            </div>
                                          </label>
                                        </div>
                                      </li>`)}
                                </ul>
                              </div>
                            `:x}
                      `;default:return n`
                        ${l.type==="multiple"?n`
                              <div
                                class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                              >
                                <ul
                                  class="list-unstyled space-y-2xs"
                                  role="list"
                                >
                                  ${$(l.options,o=>o.value,(o,d)=>n` <li
                                        class=${d>=this.facetsCheckboxVisibleLimit?'group-has-[toggle-button[data-toggled="false"]]/facet:hidden':""}
                                      >
                                        <div
                                          class="group/checkbox inline-flex items-center justify-start gap-x-xs"
                                        >
                                          <label
                                            class="relative flex cursor-pointer items-center overflow-clip rounded-[1px]"
                                            for="Filter-filter.p.${this.handleize(o.display_name)}-${t}-${d}"
                                          >
                                            <input
                                              type="checkbox"
                                              class="${window.brand=="NG"?"rounded-[2px] border-t-foreground-secondary":"border-blue-gray-200"} peer relative size-4 cursor-pointer appearance-none border transition-all checked:border-t-foreground disabled:border-t-border"
                                              id="Filter-filter.p.${this.handleize(o.display_name)}-${t}-${d}"
                                              value="${o.value}"
                                              name="${l.name}"
                                              aria-labelledby="Filter-filter.p.${this.handleize(o.display_name)}-${t}-${d}_label"
                                              .checked=${o.status!==""}
                                              @change=${this.handleCheckboxChange}
                                            />
                                            <span
                                              class="${window.brand=="NG"?"bg-t-foreground-secondary":"bg-p-darkest"} pointer-events-none absolute left-2/4 top-2/4 flex size-3 h-full w-full -translate-x-2/4 -translate-y-2/4 items-center justify-center text-p-lightest opacity-0 transition-opacity peer-checked:opacity-100 peer-disabled:border-t-border peer-disabled:text-t-border"
                                            >
                                              <svg-icon
                                                src="icon-checkbox-tick"
                                                class="block"
                                                style="--icon-size: 12px;"
                                              ></svg-icon>
                                            </span>
                                          </label>
                                          <label
                                            class="text-body mt-px cursor-pointer select-none break-all capitalize text-t-foreground group-has-[:disabled]/checkbox:text-t-border"
                                            for="Filter-filter.p.${this.handleize(o.display_name)}-${t}-${d}"
                                          >
                                            ${o.display_name}
                                          </label>
                                        </div>
                                      </li>`)}
                                </ul>
                                ${l.options.length>this.facetsCheckboxVisibleLimit?n`
                                      <toggle-button
                                        role="button"
                                        data-toggled="false"
                                        class="group/toggle-button ${window.brand=="NG"?"text-t-foreground-secondary font-bold":"text-t-foreground"} text-utility-bold mt-md underline md:mt-xs"
                                      >
                                        <span
                                          class='group-data-[toggled="true"]/toggle-button:hidden'
                                          >${this.textViewAllCount.replace("{{ count }}",`${l.options.length}`)}</span
                                        >
                                        <span
                                          class='group-data-[toggled="false"]/toggle-button:hidden'
                                          >${this.textHideCount.replace("{{ count }}",`${l.options.length-this.facetsCheckboxVisibleLimit}`)}</span
                                        >
                                      </toggle-button>
                                    `:x}
                              </div>
                            `:x}
                      `}})()}
              </details>
            `)}
        </div>
        ${t=="Mobile"?n`
              <div
                class="group/toggle-clear-all flex w-full flex-col items-center justify-center gap-xs border-t border-t-border bg-t-background px-pagegridmargin py-sm"
                data-show-clear-all=${(s??0)>0}
              >
                <dialog-toggle modal-id="${r}" class="w-full">
                  <button class="btn w-full" variant="primary">
                    ${(a==null?void 0:a.replace("{{ count }}",((u=(i=this.collectionsData)==null?void 0:i.totalResults)==null?void 0:u.toString())??""))??""}
                  </button>
                </dialog-toggle>
                <button
                  class='text-utility-bold block cursor-pointer text-t-foreground underline group-data-[show-clear-all="false"]/toggle-clear-all:hidden'
                  target-clear-all-filters
                  @click=${this.clearAllFilters}
                >
                  ${this.textClearAll}
                </button>
              </div>
            `:x}
      </div>
    `}getSortHTML(e,t){return n`
      ${t=="Desktop"?n` <facet-filters-form
            section-id="facet-filters"
            data-mode="sort"
            class="max-md:hidden"
          >
            <form
              id="SortOptionsForm${t}"
              class="gap-2xs${window.brand=="TFC"?" !font-normal":""} text-utility-bold flex"
            >
              <label for="SortBy">${this.textSort}:</label>
              <div class="relative">
                <select
                  name="sort_by"
                  id="SortBy"
                  class="outline-none${window.brand=="TFC"?" bg-transparent":""} block w-full appearance-none pr-sm"
                  @change=${this.handleSelectChange}
                >
                  ${$(e??[],r=>r.sort_by+t+this._constructorResponseID,r=>n`
                      <option
                        value="${r.sort_by}"
                        ?selected=${r.status!=""}
                      >
                        ${r.display_name.replace("Most Relevant","Featured")}
                      </option>
                    `)}
                </select>
                <svg-icon
                  src="icon-select-arrow"
                  class="pointer-events-none absolute right-0 top-2/4 -translate-y-2/4"
                  style="--icon-size: 16px;"
                ></svg-icon>
              </div>
            </form>
          </facet-filters-form>`:n` <facet-filters-form
            section-id="facet-filters"
            data-mode="sort"
            class="flex h-full"
          >
            <form
              id="SortOptionsForm${t}"
              class="flex w-full flex-col"
            >
              <div
                id="SortOptionsForm${t}_sort"
                class="group/facet max-md:px-pagegridmargin max-md:py-md md:pb-sm"
                sub-section-id="SortOptionsForm${t}_sort"
                data-sort-by="title-ascending"
              >
                <ul class="list-unstyled space-y-xs md:space-y-2xs" role="list">
                  ${$(e??[],r=>r.sort_by+t,r=>n`
                      <li class="py-2xs" data-selected="false">
                        <div
                          class="group/radio inline-flex items-start justify-start gap-x-xs"
                        >
                          <div
                            class="peer relative flex cursor-pointer items-center rounded-full"
                          >
                            <input
                              type="radio"
                              class="peer relative size-4 cursor-pointer appearance-none rounded-full border border-t-foreground-secondary text-t-foreground-secondary transition-all checked:border-t-foreground-secondary disabled:border-t-border"
                              id="sortoptionsform${t}_input_${r.sort_by}"
                              name="sort_by"
                              value="${r.sort_by}"
                              @change=${this.handleSelectChange}
                              .checked=${r.status!=""}
                            />
                            <span
                              class="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 scale-0 text-t-foreground opacity-0 transition-[opacity,transform-] peer-checked:scale-100 peer-checked:opacity-100"
                            >
                              <svg-icon
                                src="icon-radio-circle"
                                class="block"
                                style="--icon-size: 10px;"
                              ></svg-icon>
                            </span>
                          </div>
                          <label
                            class="mt-px cursor-pointer select-none"
                            for="sortoptionsform${t}_input_new-arrivals8"
                          >
                            <div>
                              <p
                                id="sortoptionsform${t}_input_new-arrivals8_label"
                                class="text-body block leading-none text-t-foreground group-has-[:disabled]/radio:text-t-disabled"
                              >
                                ${r.display_name.replace("Most Relevant","Featured")}
                              </p>
                            </div>
                          </label>
                        </div>
                      </li>
                    `)}
                </ul>
              </div>
            </form>
          </facet-filters-form>`}
    `}getPaginationArray(e,t){const s=[];if(s.push("1"),t<=6)for(let a=2;a<t;a++)s.push(a);else if(e<=3){for(let a=2;a<=4;a++)s.push(a);s.push("...")}else if(e>=t-2){s.push("...");for(let a=t-3;a<t;a++)s.push(a)}else s.push("..."),s.push(e-1),s.push(e),s.push(e+1),s.push("...");return s[s.length-1]!==t&&s.push(t),s.map(a=>a.toString())}getPaginateHTML(e,t=1){if(!e)return;const r=this.getPaginationArray(t,e.length);if(r)return n`
      ${(e==null?void 0:e.length)>1?n`
            <div class="flex justify-center px-lg pb-lg pt-md">
              <ul
                class="flex list-none items-center justify-center gap-2.5"
                role="list"
              >
                ${(e==null?void 0:e.length)>1?n`
                      <li class="inline-flex list-none">
                        <button
                          class="${t===1?"cursor-not-allowed opacity-40":""} flex h-11 items-center justify-center"
                          data-direction="-1"
                          ?disabled=${t===1}
                          aria-disabled="${t===1}"
                          @click=${this.paginateArrowClick}
                        >
                          <svg-icon
                            src=${window.brand==="TFC"?"icon-arrow-curved":"icon-caret"}
                            class="block${window.brand==="TFC"?" text-t-accent-01":""} pointer-events-none"
                            style="--icon-size: 16px;${window.brand==="TFC"?"":" rotate: 90deg;"}"
                          ></svg-icon>
                        </button>
                      </li>
                    `:x}
                ${$(r,s=>"productPage"+s,s=>n`
                    ${s!="..."?n`
                          <li class="inline-flex list-none">
                            <button
                              class="${s==t.toString()?`${window.brand=="NG"?"border-t-foreground-secondary bg-t-accent-04":"border-t-foreground"}`:"border-t-border"} ${window.brand=="NG"?"rounded-full":"rounded-sm"} flex h-11 w-11 items-center justify-center border"
                              aria-current="${s==t.toString()?"page":x}"
                              @click=${this.paginateHandleClick}
                            >
                              <span class="utility-standard pointer-events-none"
                                >${s}</span
                              >
                            </button>
                          </li>
                        `:n`
                          <li class="inline-flex list-none">
                            <span
                              class="${window.brand=="NG"?"rounded-full":"rounded-sm"} flex h-11 w-11 items-center justify-center border border-t-border"
                            >
                              <span class="utility-standard pointer-events-none"
                                >…</span
                              >
                            </span>
                          </li>
                        `}
                  `)}
                ${(e==null?void 0:e.length)>1?n`
                      <li class="inline-flex list-none">
                        <button
                          class="${t===e.length?"cursor-not-allowed opacity-40":""} flex h-11 items-center justify-center"
                          data-direction="1"
                          ?disabled=${t===e.length}
                          aria-disabled="${t===e.length}"
                          @click=${this.paginateArrowClick}
                        >
                          <svg-icon
                            src=${window.brand==="TFC"?"icon-arrow-curved":"icon-caret"}
                            class="block${window.brand==="TFC"?" text-t-accent-01":""} pointer-events-none"
                            style="--icon-size: 16px;${window.brand==="TFC"?" rotate: 180deg;":" rotate: -90deg;"}"
                          ></svg-icon>
                        </button>
                      </li>
                    `:x}
              </ul>
            </div>
          `:x}
    `}removeFacet(e){const t=e.target;if(t.dataset.name=="price")this.currentPage=1,this.filterChanged(t.closest("collection-results-section"),t);else{const r=this.querySelector(`[target-filters][is-mobile] [name="${t.dataset.name}"][value="${t.dataset.value}"]`);r&&r.click()}}getFacetRemove(e,t){return n`
      <facet-remove
        class="flex cursor-pointer snap-center items-center gap-2xs whitespace-nowrap rounded-sm bg-t-background-secondary px-xs py-[0.438rem]"
        data-name="${e.name}"
        data-value="${e.display_name}"
        @click=${this.removeFacet}
      >
        <svg-icon
          src="icon-close"
          class="pointer-events-none block"
          style="--icon-size: 8px"
        ></svg-icon>
        <span
          class="text-utility-regular pointer-events-none text-t-foreground"
        >
          ${e.type=="range"?n`$${e.min} - $${e.max}`:e.name=="rating_tier"?n`
                  <div class="flex items-center gap-1">
                    ${$([1,2,3,4,5],r=>"star"+r+t,r=>r<=parseFloat(e.display_name)?n`<svg-icon
                              src="icon-star-full"
                              class="block text-t-accent-01"
                              style="--icon-size: 16px;"
                            ></svg-icon>`:n`<svg-icon
                              src="icon-star-empty"
                              class="block text-t-foreground-secondary"
                              style="--icon-size: 16px;"
                            ></svg-icon>`)}
                  </div>
                `:n`${e.display_name}`}
        </span>
      </facet-remove>
    `}getFilteredFacets(e,t){if(!(e!=null&&e.length))return n``;const r=(e==null?void 0:e.reduce((s,a)=>{if(a.type!=="range"){const c=a.options.filter(i=>i.status==="selected").map(i=>({...i,name:a.name}));return s.concat(c)}else{const c=Object.hasOwn(a.status,"min")&&Object.hasOwn(a.status,"max"),i=a.status.min!==a.min,u=a.status.max<(this._productsMaxPrice??a.max);return c&&(i||u)&&s.push({...a,min:a.status.min,max:a.status.max}),s}},[]))??[];return n`
      <div
        class="empty:pt-0${t=="Desktop"?" max-md:hidden":""} col-span-full w-full pt-sm empty:hidden"
        data-target-facet-removes="${t==null?void 0:t.toLowerCase()}"
      >
        ${r.length>0?n` <facet-filters-form
              section-id="facet-filters"
              class="[&amp;[loading]]:opacity-50 [&amp;[loading]]:pointer-events-none flex h-full w-full"
              data-mode="facet-removes"
              data-form-id="FacetRemovesForm${t}"
              data-filters-form-id="FacetFiltersForm${t}"
            >
              <form
                id="FacetRemovesForm${t}"
                class="${t=="Desktop"?"flex-wrap":"no-scrollbar overflow-x-auto snap-x snap-mandatory px-xs"} flex w-full items-center gap-2xs"
              >
                ${$(r??[],s=>s.name,s=>this.getFacetRemove(s,t))}
                ${t=="Desktop"?n`<facet-remove
                      class="text-utility-bold ml-2xs cursor-pointer text-t-foreground underline"
                      target-clear-all-filters
                      @click=${this.clearAllFilters}
                    >
                      ${this.textClearAll}
                    </facet-remove>`:x}
              </form>
            </facet-filters-form>`:x}
      </div>
    `}getModalDialog(e,t,r,s,a,c,i,u,l,p){return n`
      <modal-dialog
        cloak
        type="${a}"
        id="${e}"
        anchor="${t}"
        close-on-backdrop-click="true"
        drawer-classes="${l}"
        header-classes="${p}"
        close-icon-size="${i}"
      >
        <h5 slot="header" class="${u} h6">${c}</h5>
        <div slot="additional-content">${s}</div>
        <form target-filters is-mobile class="h-full">${r}</form>
      </modal-dialog>
    `}render(){var e,t,r,s,a,c,i,u;return n`<collection-results-section
      class="grid grid-cols-1 px-pagegridmargin pb-sm 2xl:container max-md:px-0 md:grid-cols-[minmax(0,295px)_minmax(0,1fr)] md:gap-x-lg md:gap-y-xs"
      data-pagination-results-per-page="${this.resultsPerPage}"
      target-content-results
      data-cnstrc-browse
      data-cnstrc-filter-name="group_id"
      data-cnstrc-filter-value="${this.collectionHandle}"
      data-cnstrc-num-results="${((e=this.collectionsData)==null?void 0:e.totalResults)??0}"
      data-loaded="${!!this.collectionsData.cards}"
      style="content-visibility: auto; contain-intrinsic-size: 0 2000px;"
    >
      ${this.getFilteredFacets(this.collectionsData.facets,"Desktop")}
      <aside class="md:block md:pb-6">
        <div class="max-md:hidden">
          <form target-filters>
            ${this.getFacetsHTML(this.collectionsData.facets,"Desktop")}
          </form>
        </div>

        ${this.getModalDialog("filter-drawer-dialog-content","left",this.getFacetsHTML(this.collectionsData.facets,"Mobile","filter-drawer-dialog-content"),this.getFilteredFacets(this.collectionsData.facets,"Mobile"),"drawer",this.textFilterResults,13,"!h4","!max-w-[22.5rem] !overflow-clip !text-t-foreground","!px-0 !py-md [&_.title-container]:!px-xs")}
        ${this.getModalDialog("sort-options-drawer-dialog-content","left",this.getSortHTML((t=this.collectionsData)==null?void 0:t.sortOptions,"Mobile"),n``,"drawer",this.textSort,13,"!h4","!max-w-[22.5rem]")}
      </aside>

      <div class="flex-grow" content-category-results="resources">
        <div>
          <div>
            <div
              id="content-grid-header-search"
              class="product-grid-header mb-sm flex flex-col md:mt-sm md:flex-row md:items-center md:justify-between md:gap-sm"
            >
              <div
                class="flex${window.brand=="NG"?" max-md:bg-t-background-secondary":""}"
              >
                <dialog-toggle
                  modal-id="filter-drawer-dialog-content"
                  class="w-full md:hidden"
                >
                  <button
                    class="flex h-button-height w-full items-center justify-center gap-2xs border border-t-border text-t-foreground"
                    aria-expanded="false"
                  >
                    <svg-icon
                      src="icon-filters"
                      class="block"
                      style="--icon-size: 25px;"
                    ></svg-icon>
                    <span class="text-utility-bold font-medium"
                      >${this.textFilter}</span
                    >
                  </button>
                </dialog-toggle>
                <dialog-toggle
                  modal-id="sort-options-drawer-dialog-content"
                  class="w-full md:hidden"
                >
                  <button
                    class="flex h-button-height w-full items-center justify-center gap-2xs border-y border-r border-t-border text-t-foreground"
                    aria-expanded="false"
                  >
                    <svg-icon
                      src="icon-sorting"
                      class="block"
                      style="--icon-size: 25px;"
                    ></svg-icon>
                    <span class="text-utility-bold font-medium"
                      >${this.textSort}</span
                    >
                  </button>
                </dialog-toggle>
                ${this.getSortHTML((r=this.collectionsData)==null?void 0:r.sortOptions,"Desktop")}
              </div>
              <span
                class="${window.brand=="NG"?"text-t-disabled":"text-t-foreground-secondary"} text-utility-regular max-md:mb-2xs max-md:mt-sm max-md:w-full max-md:px-pagegridmargin md:order-[-1]"
              >
                ${(s=this.collectionsData)!=null&&s.totalResults?(((a=this.collectionsData)==null?void 0:a.totalResults)==1?this.dataResultsGridWithCountOne:this.dataResultsGridWithCountOther).replace("{{ count }}",`${(i=(c=this.collectionsData)==null?void 0:c.totalResults)==null?void 0:i.toLocaleString("en-US")}`):x}
              </span>
            </div>
            <div>
              <div
                class="grid grid-cols-2 gap-x-xs gap-y-md max-md:px-pagegridmargin lg:grid-cols-4 lg:gap-y-7"
              >
                ${$(((u=this.collectionsData)==null?void 0:u.cards)??[],l=>l.handle,l=>n`
                    <dynamic-product-card
                      handle="${l.handle}"
                      class="group/dynamic-product-card"
                      query-params="${this.collectionHandle.includes("free")&&this.collectionHandle.includes("samples")?"free-sample=true":""}"
                      template="${this.enableBundle?"product-card--bundle-cta":"product-card"}"
                    >
                      <div
                        data-slot="product-card-skeleton"
                        class="relative flex w-full flex-col group-has-[a]/dynamic-product-card:hidden"
                      >
                        <div
                          data-slot="product-card-skeleton-image"
                          class="${window.brand=="NG"?"rounded-sm":""} block aspect-square animate-pulseskeleton overflow-clip bg-t-border"
                        ></div>
                        <div class="flex flex-col gap-2xs pt-2.5">
                          <div
                            data-slot="product-card-skeleton-title"
                            class="${window.brand=="NG"?"rounded-sm":""} ${window.brand=="TFC"||window.brand=="WSP"?"pb-px":""} text-heading-6 box-content h-[1lh] max-w-[90%] animate-pulseskeleton bg-t-border font-medium leading-[1.2]"
                          ></div>
                          <div
                            data-slot="product-card-skeleton-reviews"
                            class="${window.brand=="NG"?"rounded-sm":""} mt-2xs h-2.5 max-w-[3.75rem] animate-pulseskeleton bg-t-border"
                          ></div>
                          <div
                            data-slot="product-card-skeleton-price"
                            class="${window.brand=="NG"?"rounded-sm":""} text-utility-regular mt-2xs h-[1lh] max-w-[7.75rem] animate-pulseskeleton bg-t-border"
                          ></div>
                        </div>
                      </div>
                    </dynamic-product-card>
                  `)}
              </div>
            </div>
            ${this.getPaginateHTML(this.collectionsData.paginationIds,this.currentPage)}
          </div>
        </div>
      </div>
    </collection-results-section>`}};m([h({type:String,attribute:"data-content"})],g.prototype,"textContent",2);m([h({type:String,attribute:"data-sort"})],g.prototype,"textSort",2);m([h({type:String,attribute:"data-filter"})],g.prototype,"textFilter",2);m([h({type:String,attribute:"data-filter-counter"})],g.prototype,"textFilterCounter",2);m([h({type:String,attribute:"data-filters-counter"})],g.prototype,"textFiltersCounter",2);m([h({type:String,attribute:"data-see-result"})],g.prototype,"textDataSeeResult",2);m([h({type:String,attribute:"data-see-results"})],g.prototype,"textDataSeeResults",2);m([h({type:String,attribute:"data-from"})],g.prototype,"textFrom",2);m([h({type:String,attribute:"data-to"})],g.prototype,"textTo",2);m([h({type:String,attribute:"data-hide-count"})],g.prototype,"textHideCount",2);m([h({type:String,attribute:"data-view-all-count"})],g.prototype,"textViewAllCount",2);m([h({type:String,attribute:"data-apply"})],g.prototype,"textApply",2);m([h({type:String,attribute:"data-clear-all"})],g.prototype,"textClearAll",2);m([h({type:String,attribute:"data-results-grid-with-count-one"})],g.prototype,"dataResultsGridWithCountOne",2);m([h({type:String,attribute:"data-results-grid-with-count-other"})],g.prototype,"dataResultsGridWithCountOther",2);m([h({type:Number,attribute:"data-products-per-page"})],g.prototype,"resultsPerPage",2);m([h({type:String,attribute:"data-handle"})],g.prototype,"collectionHandle",2);m([h({type:Object})],g.prototype,"collectionsData",2);m([h({type:Number})],g.prototype,"facetsCheckboxVisibleLimit",2);m([h({type:Number})],g.prototype,"currentPage",2);m([h({type:Boolean,attribute:"enable-bundle"})],g.prototype,"enableBundle",2);m([h({type:String})],g.prototype,"textFilterResults",2);g=m([D("collection-results")],g);
